<!--
 * @Author: hfxie
 * @Date: 2021-01-01 14:52:54
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-10-31 16:05:57
 * @Description: 甘特图右侧下方区背景网格线
-->
<!-- 甘特图背景网格 -->
<template>
  <div class="gantt-bg" ref="bg" :class="{'drag-act': dragStatus}" :style="getHeight">
    <!-- 列 -->
    <div class="cols">
      <template v-for="(item2, index2) in cols">
        <div
          class="cell-col"
          :class="{
            'holiday-1': (item2.holidayType === 1 && $store.state.viewSchem.weekedBgShow),
            'holiday-2': (item2.holidayType === 2 || item2.holidayType === 3),
          }"
          :key="item2.date.format('YYYY-MM-DD HH:mm:ss')"
          :style="{
            'width': $store.getters.cellWidth + 'px',
            'left': index2 * $store.getters.cellWidth + 'px',
            'border-left-style': (index2 != 0 && gridYBgConfig.isShow && (index2 + 1) % gridYBgConfig.step == 0)? gridYBgConfig.type: '',
            'background-color': (item2.holidayType === 2 || item2.holidayType === 3)? item2.holidayColor: undefined,
          }"
        ></div>
      </template>
    </div>
    <!-- 行·仅区分拖拽识别 -->
    <div class="rows" v-if="$store.getters.dropTargetType === 2">
      <template v-for="(row, indRow) in rowsShow">
        <div
          class="gantt-row"
          :key="row.id"
          :data-name="row.name"
          :data-id="row.id"
          :style="{
            'border-bottom-style': ((indRow != rowsShow.length - 1) && gridXBgConfig.isShow && indRow % gridXBgConfig.step == 0)? gridXBgConfig.type: '',
            'height': ((row.rowCount? row.rowCount: 1) * estimatedItemSize  + 'px'),
          }"
        >
        </div>
      </template>
    </div>
    <div class="rows" v-else>
      <template v-for="(row, indRow) in rowsShow">
        <div
          class="gantt-row"
          :key="row.id"
          :data-name="row.name"
          :data-id="row.id"
          :style="{
            'border-bottom-style': ((indRow != rowsShow.length - 1) && gridXBgConfig.isShow && indRow % gridXBgConfig.step == 0)? gridXBgConfig.type: '',
            'height': ((row.rowCount? row.rowCount: 1) * estimatedItemSize  + 'px'),
          }"
          @dragenter.stop.prevent
          @dragover.stop.prevent="DragMove"
          @dragleave.stop.prevent
          @drop.stop.prevent="DropHandle($event, row)"
        >
        </div>
      </template>
    </div>

  </div>
</template>
<script>
export default {
  name: "ContentBg",
  props: {
    rowsShow: {
      type: Array,
      default: () => { return []; },
    },
    cols: {
      type: Array,
      default: () => { return []; },
    },
    rowsShowMap: {
      type: Object,
      default: () => { return null; },
    },
    totalHeight: {
      type: Number,
      default: () => { return 0; },
    },
    gridXBgConfig: {
      type: Object,
      default: () => {
        return {
          isShow: false,
          step: 0,
          type: "solid",
        };
      },
    },
    gridYBgConfig: {
      type: Object,
      default: () => {
        return {
          isShow: false,
          step: 0,
          type: "solid",
        };
      },
    },
    isDragging: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    // 预估行高度
    estimatedItemSize: {
      type: Number,
      default: () => { return 50; },
    },
  },
  data() {
    return {
      ganttType: this.rowsShow.length > 0 ? this.rowsShow[0].ganttType : "pageData",
    };
  },
  inject: ["CONSTNAME"],
  computed: {
    dragStatus() {
      const isMultiple = this.$store.state.viewSchem.ganttNums > 1;
      const result = (this.isDragging || isMultiple);
      return result;
    },
    getHeight() {
      let ganttBgCss = "";
      if (this.totalHeight === 0) {
        ganttBgCss = "";
      } else {
        ganttBgCss = {
          "height": this.totalHeight + "px",
        };
      }
      return ganttBgCss;
    },
  },
  mounted() {},
  methods: {
       // 设置斑马纹
    setBG(index){
      if(index%2==0){
        return '#F4F4F4'
      }else{
        return 'rgba(255,255,255,1)'
      }
    },
    // 鼠标移动位置信息
    getPos(ev) {
      const scrollTop = this.$refs.bg.parentNode.scrollTop || document.body.scrollTop;
      const scrollLeft = this.$refs.bg.parentNode.parentNode.parentNode.parentNode.scrollLeft || document.body.scrollLeft;
      return { x: ev.clientX + scrollLeft, y: ev.clientY + scrollTop, scroll_x: scrollLeft, scroll_y: scrollTop };
    },
    // 移动过程处理 指示线
    DragMove(e) {
      if (this.$store.state.viewSchem.isDropYAxisShow) {
        try {
          if (
            this.$store.state.viewSchem.dropTargetType !== 1 &&
            window.sessionStorage.dragInfo_common_gantt
          ) {
            // console.log("不支持的数据拖动");
            return false;
          }
          const _dragInfo = JSON.parse(window.sessionStorage.dragInfo_common_gantt);
          const { x, dragItem } = _dragInfo;
          const _dragE = this.getPos(e);
          const _diffX = _dragE.x - x; // 移动的横向距离
          const _diffLCB = dragItem.crossObjName == "landmarks" ? 10 : 0; // 里程碑中心偏移量
          const _diffPosLeft = dragItem._left + _diffX + _diffLCB; // 最新图中位置待转换成时间戳
          const _summaryHeight = (this.$store.state.summaryShow ? (this.$store.state[this.CONSTNAME.SUMMARY + "_rowsNum"] * this.$store.state.summaryCellHeight) : 0) + 1;
          const _height = `calc(100% - ${_summaryHeight}px)`;
          const guideYAxis = {
            isShow: true,
            key: "guideYAxis-" + dragItem.taskId,
            "left": _diffPosLeft + "px",
            "height": _height,
            "zIndex": 10000,
            "color": "#FF0000",
            "type": "solid",
            "width": 1,
          };
          this.$store.commit("set_guideYAxis", guideYAxis);
        } catch (error) {
          console.log("不支持的数据拖动", error);
          return false;
        }
      }
    },
    DropHandle(e, item) {
      this.$store.commit("set_isDragging", false);
      // console.log("行内释放", e, item);
      if (e.dataTransfer.getData("dragInfo") === "") {
        // console.log("不支持的数据拖动");
        return false;
      }
      e.preventDefault();
      e.stopPropagation();
      const _baseWidth = this.$store.getters.cellWidth;
      const _dragInfo = JSON.parse(e.dataTransfer.getData("dragInfo"));
      const { x, y, dragItem, ganttType } = _dragInfo;
      console.log("拖拽投放: ", item, dragItem, e.clientX, e.clientY);
      /* 换算新时间 所属行id */
      const _dragE = this.getPos(e);
      const _diffX = _dragE.x - x; // 移动的横向距离
      const _diffLCB = dragItem.crossObjName == "landmarks" ? 10 : 0; // 里程碑中心偏移量
      const _diffPosLeft = dragItem._left + _diffX + _diffLCB; // 最新图中位置待转换成时间戳
      if (!item.dropable) {
        const demoKey = this.$store.state.langMap.dragErrorMsg; // "目标行无效，请重新选择释放横道位置。"
        return this.$Message({
          message: demoKey,
          type: "warning",
          showClose: true,
          // offset: 220,
        });
      }
      let _newNum = Math.floor(_diffPosLeft / _baseWidth);
      if (_newNum < 2) {
        _newNum = 2;
      }

      // 转换不同放置容器的位置差
      // const _olditem = this.$store.state[ganttType + "_tasksArr"][dragItem._selfIndex];
      // const _target = this.$utils.deepClone(_olditem);
      const _target = this.$utils.deepClone(dragItem);

      let _baseTime = 1000 * 60 * 60 * 24;
      switch (this.$store.state.cellUnitType) {
          case "day":
            _baseTime = 1000 * 60 * 60 * 24;
            break;
          case "month":
            _baseTime = 1000 * 60 * 60 * 24 * 30;
            break;
          case "week":
            _baseTime = 1000 * 60 * 60 * 24 * 7;
            break;
          case "hour":
            _baseTime = 1000 * 60 * 60;
            break;
          default:
            _baseTime = 1000 * 60 * 60 * 24;
            break;
      }
      const _newStartTime = this.$store.getters.totalStartAndEnd.start + _newNum * _baseTime;
      const _diffTime = parseInt(_target.startDate) - _newStartTime;
      const _newEndTime = dragItem.crossObjName == "landmarks" ? _newStartTime : _target.endDate - _diffTime;

      if (item.id == dragItem.groupId && _diffTime === 0) {
        return this.$Message({
          message: "取消移动: 起点无变化",
          type: "warning",
          showClose: true,
        });
      }
      /* 提交 */
      _target.startDate = _newStartTime;
      _target.endDate = _newEndTime;
      const dropEndInfo = {
        item: _target,
        targetGanttType: this.ganttType, // 待交换的目标数据源
        targetGroupId: item.id, // 待交换的目标行id
        targetEntityFlag: item.entityFlag, // 待交换的目标行标识(后端需要)
        index: dragItem._selfIndex,
        mapKey: item.id, // 行字典中的key
        targetRow: item,
      };
      this.$store.dispatch("_dragTask", dropEndInfo);
      // this.ResetDashLines();
      console.log("最终拖放结果:", dropEndInfo);
      this.$emit("ResetDashLines");
      e.dataTransfer.clearData();
    },

  },
};

</script>
<style scoped lang='less'>
.gantt-bg{
  &.drag-act{
    .rows{
      position: relative;
      z-index: 505; // 405禁用拖拽
    }
  }
  position: relative;
  height: 100%;
  .rows{
    .gantt-row {
      overflow: hidden;
      position: relative;
      display: block;
      border-color: @cBorderX;
      border-color: var(--borderX-color, @cBorderX);
      border-width: 1px;
      // &.act {
      //   background-color: @bgActRow;
      // }
      /* &.disable {
        // background-color: rgba(225,225,225,0.2);
        background-color: #eceef1;
        .task-bg-slant;
      } */
      &.task-info-row-isSelect{
        background: @cWBSRowBg;
      }
    }
  }
  .cols{
    .cell-col {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      box-sizing: border-box;
      width: @cellWidth;
      overflow: hidden;
      text-align: center;
      height: 100%;
      // 边线
      border-color: @cBorder;
      border-color: var(--border-color, @cBorder);
      border-width: 1px;
      /* &:first-of-type{
        border-left: 1px solid @cBorder;
        border-left: 1px solid var(--border-color, @cBorder);
      } */

      &.holiday-1{
        background-color: @cBgWeekend;
      }
      &.holiday-2{
        background-color: @cBgWeekend;
      }

    }
  }

}
</style>
